import { StatementTypes } from 'modules/clients/types/client.enum';
import { Control } from 'react-hook-form';
import SectionWrapper from '../../../atoms/section-wrapper/SectionWrapper';
import { MultiSelectStatementPeriod } from '../../../atoms/statement-period-selection-types/MultiSelectStatementPeriod';
import { SingleSelectStatementPeriod } from '../../../atoms/statement-period-selection-types/SingleSelectStatementPeriod';
import { InvestmentModelMock } from 'modules/clients/types/client.interfaces';
import { StatementFormValues } from 'modules/clients/types/client.types';

type StatementPeriodProps = {
  control: Control<StatementFormValues, StatementFormValues, StatementFormValues>;
  statementType: string | null;
  selectedInvestments: InvestmentModelMock[];
  min30DaysStart: Date;
  errorState: boolean;
  setErrorState: React.Dispatch<React.SetStateAction<boolean>>;
};
export const StatementPeriod = ({
  control,
  statementType,
  selectedInvestments,
  min30DaysStart,
  errorState,
  setErrorState
}: StatementPeriodProps) => {
  return (
    <SectionWrapper disabled={!statementType || selectedInvestments.length === 0}>
      {statementType === StatementTypes.internalRateOfReturnInv ? (
        <MultiSelectStatementPeriod
          control={control}
          min30DaysStart={min30DaysStart}
          errorState={errorState}
          setErrorState={setErrorState}
        />
      ) : (
        <SingleSelectStatementPeriod
          control={control}
          min30DaysStart={min30DaysStart}
          errorState={errorState}
          setErrorState={setErrorState}
          customPeriodRadioButtonDisabled={!statementType || selectedInvestments.length === 0}
        />
      )}
    </SectionWrapper>
  );
};
